var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tableau-viz',{attrs:{"id":"tableau-viz","src":"http://172.18.253.41/views/HIV/10Dash","width":"1000","height":"840","hide-tabs":"","toolbar":"bottom"}})}
var staticRenderFns = []

export { render, staticRenderFns }